'use strict';

const NetworkSettingsCtrl = function (CRUDService, config) {
    var ctrl = this;

    var currentPage = 0;
    var totalPages;

    ctrl.$onInit = function() {
      CRUDService.getAll(config.urls.networks, undefined, 'name,asc').then(function (data) {
        ctrl.networks = data._embedded.networks;
        totalPages = data.page.totalPages;
      });
    }

    ctrl.remove = function(item){
      CRUDService.remove(item._links.self.href).then(
        function(){
          ctrl.$onInit();
        });
    };

    ctrl.getNextPage = function() {
      if ((currentPage + 1) < totalPages) {
        currentPage++;
        CRUDService.getAll(config.urls.networks, currentPage).then(function (data) {
          ctrl.networks = ctrl.networks.concat(data._embedded.networks);
        });
      }
    };
  };

NetworkSettingsCtrl.$inject = ['CRUDService', 'config'];

module.exports = {
  template: require('./networks.html'),
  controller: NetworkSettingsCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/settings/components/settings-network/settings-network.component.js